// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgReorder = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" clipPath="url(#clip0_20603_40889)">
      <path d="M8.5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8.5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4M10.5 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4M17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.5 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    </g>
  </svg>
);
export const ReorderIcon = forwardRef(SvgReorder);
